import {Injectable} from "@angular/core";
import {ComponentBase} from "../../base/ComponentBase";
import {EventBus} from "../../event/EventBus";
import {UserModelInitializedEvent, UserModelChangedEvent} from "../../event/UserModelEvents";
import {ResetSelectionLoadedEvent} from "../../event/ContentEvents";
import {filter} from "rxjs/operators";

@Injectable()
export class SelectionRecordingStatus extends ComponentBase {

    private finishedRecording:boolean = false;

    constructor(private eventBus: EventBus) {
        super("SelectionRecordingStatus");
        this.registerObservers();
    }

    public hasFinishedRecording(): boolean {
        return this.finishedRecording;
    }

    private registerObservers(): void {
        let userModelInitialized = this.eventBus.pipe(filter(
            event => event instanceof UserModelInitializedEvent)).subscribe((event: UserModelInitializedEvent) => {
            this.finishedRecording = event.delta.canPlayback;
        });


        let userModelUpdate = this.eventBus.pipe(filter(
            event => event instanceof UserModelChangedEvent)).subscribe((event: UserModelChangedEvent) => {
            this.finishedRecording = event.delta.canPlayback;
        });

        // need to re-initialize at the selection of a new story
        let newStorySelected = this.eventBus.pipe(filter(
            event => event instanceof ResetSelectionLoadedEvent)).subscribe((event:ResetSelectionLoadedEvent) => {
            this.finishedRecording = false;
        });

        this.subscriptions.push(userModelInitialized);
        this.subscriptions.push(userModelUpdate);
        this.subscriptions.push(newStorySelected);
    }

}
